export default __webpack_public_path__ + "static/media/dairy_cat_disabled.d2628b7d.png";